
export class Option {
    constructor(
        public key: string,
        public label: string,
    ) {
    }
}
